import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useDraggable } from '@dnd-kit/core';
import { BombButton } from '../../../../panels/bombs/bombButton';
import { ALL_BOMB_PROPERTIES } from '../../../../types/bombTypes';
export const DraggableBombButton = ({ bombType }) => {
    const { attributes, listeners, setNodeRef } = useDraggable({
        id: bombType
    });
    return (_jsx("div", { "data-testid": `draggable ${bombType} button`, ref: setNodeRef, ...listeners, ...attributes, children: _jsx(BombButton, { bombProperties: ALL_BOMB_PROPERTIES[bombType], mode: 'draggable' }, bombType) }));
};
